<script>
import BaseHeader from "@/components/BaseHeader.vue";
import {mapState} from "pinia";
import {authStore} from "@/store/authStore";
import {userStore} from "@/store/userStore";
import {appStore} from "@/store/appStore";
import {maintenanceStore} from "@/store/maintenanceStore";
export default {
  name: "BaseLayout",
  components: {
    BaseHeader
  },
  computed: {
    ...mapState(appStore, [
      'hideHeaderMessageState'
    ]),
    ...mapState(maintenanceStore, [
        'isResolveContentReviewBlocked'
    ]),
    ...mapState(userStore, [
      'userHasApprovedEmail'
    ]),
    ...mapState(authStore, [
      'showCookiePolicyMessage'
    ]),
    baseContentClass() {
      let contentClass = '';

      if (!this.userHasApprovedEmail) {
        contentClass += this.hideHeaderMessageState ? '' : ' not-approved-user-header-message';
      } else if (this.showCookiePolicyMessage) {
        contentClass += ' not-accepted-cookie-header-message';
      } else if (this.isResolveContentReviewBlocked) {
        contentClass += this.hideHeaderMessageState ? '' : ' content-review-blocked';
      }

      return contentClass;
    }
  }
}
</script>

<template>
<div class="base-content-wrap" :class="baseContentClass">
  <base-header/>
  <div class="content-section-wrap">
    <div class="content-section">
      <slot></slot>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.base-content-wrap {
  background: #E9EAED;

  &--has-message {
    padding-top: 125px;
  }

  &.not-accepted-cookie-header-message {
    padding-top: 80px;
  }

  &.not-approved-user-header-message {
    padding-top: 45px;
  }

  &.content-review-blocked {
    padding-top: 45px;
  }
}

.content-section-wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
  background: #E9EAED;

  .content-section {
    width: 100%;
    max-width: 970px;
    margin-bottom: 100px;
    padding: 0 !important;
  }
}
</style>